"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cube = void 0;
const PIXI = __importStar(require("pixi.js"));
const Vector3_1 = require("../isometric/Vector3");
const Observable_1 = require("../lib/Observable");
class Cube extends PIXI.Graphics {
    constructor(options) {
        super();
        this.$options = Observable_1.Observable.create({
            width: 50,
            height: 50,
            depth: 50,
            position: new Vector3_1.Vector3(),
            faces: ['top', 'left', 'front'],
            colors: {
                top: 0x989865,
                bottom: 0x989865,
                left: 0x838357,
                right: 0x838357,
                front: 0x6f6f49,
                back: 0x6f6f49,
            },
        });
        this.$colors = {
            top: 0x989865,
            bottom: 0x989865,
            left: 0x838357,
            right: 0x838357,
            front: 0x6f6f49,
            back: 0x6f6f49,
        };
        this.$opacity = {
            top: 1,
            bottom: 1,
            left: 1,
            right: 1,
            front: 1,
            back: 1,
        };
        if (options) {
            Observable_1.Observable.set(this.$options, options);
        }
        Observable_1.Observable.subscribe(this.$options, () => this.renderCube());
        const { position, width, height, depth, colors } = this.$options;
        this.$colors = colors;
        this.$faces = {
            top: [
                new Vector3_1.Vector3(position.x, position.y, position.z),
                new Vector3_1.Vector3(position.x + width, position.y, position.z),
                new Vector3_1.Vector3(position.x + width, position.y + depth, position.z),
                new Vector3_1.Vector3(position.x, position.y + depth, position.z),
            ],
            bottom: [
                new Vector3_1.Vector3(position.x, position.y, position.z - height),
                new Vector3_1.Vector3(position.x + width, position.y, position.z - height),
                new Vector3_1.Vector3(position.x + width, position.y + depth, position.z - height),
                new Vector3_1.Vector3(position.x, position.y + depth, position.z - height),
            ],
        };
        this.$faces.back = [this.$faces.top[0], this.$faces.top[3], this.$faces.bottom[3], this.$faces.bottom[0]];
        this.$faces.left = [this.$faces.top[2], this.$faces.top[3], this.$faces.bottom[3], this.$faces.bottom[2]];
        this.$faces.right = [this.$faces.top[0], this.$faces.top[1], this.$faces.bottom[1], this.$faces.bottom[0]];
        this.$faces.front = [this.$faces.top[1], this.$faces.top[2], this.$faces.bottom[2], this.$faces.bottom[1]];
        this.renderCube();
    }
    get facesShape() {
        const { faces = [] } = this.$options;
        const shapes = {};
        for (let f of ['back', 'bottom', 'right', 'left', 'top', 'front'].filter(f => faces.includes(f))) {
            if (f in this.$faces) {
                shapes[f] = new PIXI.Polygon(this.$faces[f].map(p => p.toVector2()));
            }
        }
        return shapes;
    }
    renderCube() {
        const { facesShape } = this;
        this.clear();
        for (let f in facesShape) {
            this.beginFill(this.$colors[f], this.$opacity[f]);
            this.drawPolygon(facesShape[f]);
            this.endFill();
        }
    }
}
exports.Cube = Cube;
